import Services from 'store/Services';
import { AnyAction, MiddlewareAPI } from 'redux';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import { buildLogger } from '@instinet-analytics/core-lib';
import { isSetConfigActionFor } from 'widgets/store/actions';
import { WidgetType } from 'widgets/WidgetType';
import { selectAllActiveTopics } from 'widgets/myPortfolioCapsules/store/selectors';
import { arraysDiffer } from 'utils/arrays/arrayUtils';
import { MyPortfolioCapsulesActionType } from 'widgets/myPortfolioCapsules/store/actions';
import { LayoutActionType } from 'layout/store/actions';
import { FeatureToggleStateActionType } from 'app/store/featureToggles/actions';

export const myPortfolioCapsulesMiddleware = (services: Services) => [
    checkOrderStreamAndRecalculateAllOnActiveTopicChanged(services),
];

export function checkOrderStreamAndRecalculateAllOnActiveTopicChanged(
    services: Services
) {
    return (middlewareAPI: MiddlewareAPI<ThunkDispatch<AnyAction>, State>) =>
        (next: ThunkDispatch<AnyAction>) =>
        (action: AnyAction) => {
            const {
                loggingService,
                myPortfolioCapsulesDataService,
                ordersStreamingService,
            } = services;

            const logger = buildLogger(
                'MyPortfolioCapsules checkOrderStreamAndRecalculateAllOnActiveTopicChanged',
                loggingService
            );

            const prevState = middlewareAPI.getState();

            next(action);

            if (!actionMightAffectActiveTopics(action)) {
                return;
            }

            const nextState = middlewareAPI.getState();

            const prevTopics = selectAllActiveTopics(prevState);
            const nextTopics = selectAllActiveTopics(nextState);

            if (arraysDiffer(prevTopics, nextTopics)) {
                logger.info('Checking orders stream and recalculating... ', {
                    prevTopics,
                    nextTopics,
                });
                ordersStreamingService.startOrUpdateOrdersStream();
                myPortfolioCapsulesDataService.recalculate();
            }
        };

    function actionMightAffectActiveTopics(action: AnyAction) {
        return (
            isSetConfigActionFor(WidgetType.MY_PORTFOLIO_CAPSULES, action) ||
            action.type === MyPortfolioCapsulesActionType.INITIALISE ||
            action.type === LayoutActionType.LAYOUT_STATE_CHANGE ||
            action.type === FeatureToggleStateActionType.TOGGLE
        );
    }
}
